import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 82px 0 74px 0;
  background: center / cover no-repeat
    url("/assets/images/support/search-bg.png");

  ${mobile(css`
    width: 100%;
    padding: 32px;
  `)};

  form {
    position: relative;

    ${mobile(css`
      width: 100%;
    `)};
  }

  > form .search-input input {
    width: 296px;
    background-color: #fff;

    ${mobile(css`
      width: 100%;
    `)};
  }

  > form .search-input .post-fix {
    right: 35px;
  }

  > form button {
    right: 6px;
  }
`;

const searchInputText = styled.input`
  padding: 8px 16px;
  ${setFontStyle("Body7")};
  color: ${COLOR.grayScale_400};
  border: 1px solid ${COLOR.grayScale_400};
  border-radius: 2px;
  appearance: searchfield;

  ${mobile(css`
    width: 100%;
  `)};

  &::placeholder {
    color: ${COLOR.grayScale_400};
  }

  &:focus {
    color: ${COLOR.grayScale_700};
    border: 1px solid ${COLOR.primaryBlue_60};
  }
`;

const searchButton = styled.button`
  position: absolute;
  top: calc(50% - 10px);
  right: 12px;
  width: 20px;
  height: 20px;
  border: 0;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
`;

export default {
  container,
  searchInputText,
  searchButton,
};
